/**
 * "be" → 🇧🇪. Leer, wenn der Code kein zweistelliges ISO-Kürzel ist.
 *
 * Ein Flaggen-Emoji besteht aus zwei Regional-Indicator-Symbolen; der Abstand vom Grossbuchstaben
 * zum passenden Indicator ist konstant 0x1F1A5.
 */
export function countryFlag(code: string): string {
    if (!code || code.length !== 2) return '';
    return [...code.toUpperCase()].map((c) => String.fromCodePoint(c.codePointAt(0)! + 0x1f1a5)).join('');
}
